import { useQuery } from '@tanstack/react-query';

import { CloudForwarderForwarders } from '@graylog/enterprise-api';

import { defaultOnError } from 'util/conditional/onError';

const BASIC_FORWARDER_USER_QUERY_KEY = 'basic_forwarder_user';

export type BasicForwarderUser = {
  serviceAccount: boolean;
  fullName: string;
  readOnly: boolean;
  id: string;
  username: string;
};

const getForwarderUser = async (): Promise<BasicForwarderUser> =>
  CloudForwarderForwarders.getBasicForwarderUser().then((userResponse) => ({
    serviceAccount: userResponse.service_account,
    fullName: userResponse.full_name,
    readOnly: userResponse.read_only,
    id: userResponse.id,
    username: userResponse.username,
  }));

const useBasicForwarderUser = (): {
  data: BasicForwarderUser;
  isLoading: boolean;
  refetch: () => void;
} => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [BASIC_FORWARDER_USER_QUERY_KEY],
    queryFn: () =>
      defaultOnError(getForwarderUser(), `Loading Forwarder User failed with status`, `Could not load Forwarder User`),
  });

  return {
    data,
    isLoading,
    refetch,
  };
};

export default useBasicForwarderUser;
